// 案件詳細での「契約書を表示する」ボタン
import React from 'react';
import CenterButton from '../atoms/CenterButton';
import Heading from './Heading';
import Paragraph from '../molecules/Paragraph';

interface Props {
  heading_disabled?: boolean;
  reception_id: number;
  is_signer: boolean;
}

const ShowContractButton: React.FC<Props> = ({ heading_disabled, reception_id, is_signer }) => {
  // 契約書確認画面に遷移
  const handleClick = () =>
    location.replace(
      `${location.origin}${process.env.MIX_MOCK_URL}/confirm_contract?r_id=${reception_id}`
    );

  return (
    <div className="mt-5">
      {!heading_disabled && <Heading label="電子契約書" size="s" />}
      {is_signer ? (
        <CenterButton
          label="契約書を表示する"
          btn_class="btn-base arrow-right"
          handleClick={handleClick}
        />
      ) : (
        <Paragraph label="電子署名済の契約書はありません。" is_paragraph={false} />
      )}
    </div>
  );
};

export default ShowContractButton;
